import Swiper from "swiper";
import {
  Navigation,
  FreeMode,
  Thumbs,
  Zoom,
  Autoplay,
  Keyboard,
} from "swiper/modules";

Swiper.use([Navigation, FreeMode, Thumbs, Zoom, Autoplay, Keyboard]);

const bind = function () {
  if ($(".hasHeadshot").length > 0) {
    const dynOneMultiOneSwiper = new Swiper(
      "[data-pl-carousel=dynOneMultiOne]",
      {
        slidesPerView: 2,
        spaceBetween: 10,
        lazy: true,
        freeMode: {
          enabled: true,
        },
        loop: true,
        breakpoints: {
          0: {
            slidesPerView: 2.3,
          },
          576: {
            slidesPerView: 3.3,
          },
          768: {
            slidesPerView: 2.3,
          },
          992: {
            slidesPerView: 3.3,
          },
          1200: {
            slidesPerView: 4.3,
          },
          1400: {
            slidesPerView: 5.3,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    );
  } else {
    const dynOneMultiOneSwiper = new Swiper(
      "[data-pl-carousel=dynOneMultiOne]",
      {
        slidesPerView: 2,
        spaceBetween: 10,
        lazy: true,
        freeMode: {
          enabled: true,
        },
        loop: true,
        breakpoints: {
          0: {
            slidesPerView: 2.3,
          },
          576: {
            slidesPerView: 3.4,
          },
          768: {
            slidesPerView: 4.4,
          },
          992: {
            slidesPerView: 5.4,
          },
          1200: {
            slidesPerView: 6.4,
          },
          1400: {
            slidesPerView: 7.4,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    );
  }

  const articleCarousel = new Swiper("[data-pl-carousel=articleCarousel]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 1.4,
      },
      576: {
        slidesPerView: 2.4,
      },
      768: {
        slidesPerView: 3.4,
      },
      992: {
        slidesPerView: 4.4,
      },
      1200: {
        slidesPerView: 4.4,
      },
      1400: {
        slidesPerView: 5.4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const popularCatSwiper = new Swiper("[data-pl-carousel=popCat]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 2.4,
      },
      576: {
        slidesPerView: 4.4,
      },
      768: {
        slidesPerView: 5.4,
      },
      992: {
        slidesPerView: 6.4,
      },
      1200: {
        slidesPerView: 7.4,
      },
      1400: {
        slidesPerView: 8.4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Blok PRODUCTS w treści artykułu (edytor Hydry): 4 produkty na szerokość kolumny.
  const articleProducts = new Swiper("[data-pl-carousel=articleProducts]", {
    slidesPerView: 4,
    spaceBetween: 10,
    lazy: true,
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1.5,
      },
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const prodInspiring = new Swiper("[data-pl-carousel=fourToOne]", {
    slidesPerView: 2,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 1.4,
      },
      576: {
        slidesPerView: 2.4,
      },
      768: {
        slidesPerView: 3.4,
      },
      992: {
        slidesPerView: 4.4,
      },
      1200: {
        slidesPerView: 4.4,
      },
      1400: {
        slidesPerView: 5.4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const servicesProductsSwiper = new Swiper("[data-pl-carousel=servicesProducts]", {
      slidesPerView: 2,
      lazy: true,
      freeMode: {
        enabled: true,
      },
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 1.4,
        },
        576: {
          slidesPerView: 2.4,
        },
        768: {
          slidesPerView: 3.4,
        },
        992: {
          slidesPerView: 3.4,
        },
        1200: {
          slidesPerView: 3.4,
        },
        1400: {
          slidesPerView: 4.4,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    }
  );

  const recommendedBrands = new Swiper("[data-pl-carousel=recommendedBrands]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: true,
    breakpoints: {
        0: {
            slidesPerView: 2.4,
        },
        576: {
            slidesPerView: 2.4,
        },
        768: {
            slidesPerView: 3.4,
        },
        992: {
            slidesPerView: 4.4,
        },
        1200: {
            slidesPerView: 5.4,
        },
        1400: {
            slidesPerView: 6.4,
        },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const bestsellersSwiper = new Swiper("[data-pl-carousel=bestsellers]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 2.4,
      },
      576: {
        slidesPerView: 2.4,
      },
      768: {
        slidesPerView: 3.4,
      },
      992: {
        slidesPerView: 4.4,
      },
      1200: {
        slidesPerView: 5.4,
      },
      1400: {
        slidesPerView: 6.4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const newProducts = new Swiper("[data-pl-carousel=newProducts]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 2.4,
      },
      576: {
        slidesPerView: 2.4,
      },
      768: {
        slidesPerView: 3.4,
      },
      992: {
        slidesPerView: 4.4,
      },
      1200: {
        slidesPerView: 5.4,
      },
      1400: {
        slidesPerView: 6.4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const lastProductsSwiper = new Swiper("[data-pl-carousel=lastProducts]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 2.4,
      },
      576: {
        slidesPerView: 3.4,
      },
      768: {
        slidesPerView: 4.4,
      },
      992: {
        slidesPerView: 5.4,
      },
      1200: {
        slidesPerView: 6.4,
      },
      1400: {
        slidesPerView: 7.4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const similiarProducts = new Swiper("[data-pl-carousel=similarProducts]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    freeMode: {
      enabled: true,
    },
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 2.4,
      },
      576: {
        slidesPerView: 3.4,
      },
      768: {
        slidesPerView: 4.4,
      },
      992: {
        slidesPerView: 4.4,
      },
      1200: {
        slidesPerView: 5.4,
      },
      1400: {
        slidesPerView: 6.4,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const thumbnailsProductSwiper = new Swiper(
    "[data-pl-carousel=thumbnailsProductSwiper]",
    {
      slidesPerView: 4,
      spaceBetween: 10,
      watchSlidesProgress: true,
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // od lg miniatury stoją w pionowej kolumnie obok zdjęcia (układ robi grid
        // na .product-gallery), niżej zostaje pasek pod zdjęciem. Kolumna ma wysokość
        // zdjęcia głównego, więc mieści o jedną miniaturę więcej niż pasek
        992: {
          direction: "vertical",
          slidesPerView: 5,
        },
      },
    }
  );

  const productSlider = new Swiper("[data-pl-carousel=productSlider]", {
    slidesPerView: 1,
    spaceBetween: 10,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbnailsProductSwiper,
    },
    on: {
      slideChange: function () {
        $("#position-number span").text(
          this.realIndex + 1 + " z " + this.slides.length
        );
      },
      init: function () {
        $("#position-number span").text(
          this.realIndex + 1 + " z " + this.slides.length
        );
      },
    },
  });

  const productSliderThumbnailsInModal = new Swiper(
    "[data-pl-carousel=productSliderThumbnailsInModal]",
    {
      slidesPerView: 5,
      spaceBetween: 10,
      lazy: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 5,
        },
        992: {
          slidesPerView: 6,
        },
      },
    }
  );

  const productSliderModal = new Swiper(
    "[data-pl-carousel=productSliderInModal]",
    {
      zoom: {
        maxRatio: 2,
        toggle: true,
      },
      slidesPerView: 1,
      spaceBetween: 20,
      lazy: true,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: productSliderThumbnailsInModal,
      },
      on: {
        slideChange: function () {
          $("#position-number-modal span").text(
            this.realIndex + 1 + " z " + this.slides.length
          );
        },
      },
    }
  );

  const accountSwiper = new Swiper("[data-pl-carousel=accountSwiper]", {
    slidesPerView: 2,
    spaceBetween: 10,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const productCategoriesSwiper = new Swiper(
    "[data-pl-carousel=prod-list-cat-swiper]",
    {
      slidesPerView: 4,
      spaceBetween: 10,
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
        },
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
      },
    }
  );

  const addressSwiper = new Swiper("[data-pl-carousel=addressSwiper]", {
    spaceBetween: 10,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
    },
  });

  const addressSwiperOne = new Swiper("[data-pl-carousel=addressSwiperOne]", {
    slidesPerView: 1,
    spaceBetween: 25,
    lazy: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  $(function () {
    const productSliderModal1 = $("#productSliderModal");

    if (productSliderModal1.length) {
      productSliderModal1.on("shown.bs.modal", function () {
        const index =
          typeof productSlider?.realIndex === "number"
            ? productSlider.realIndex
            : 0;
        const currentModalIdx =
          typeof productSliderModal?.realIndex === "number"
            ? productSliderModal.realIndex
            : -1;
        if (index !== currentModalIdx) {
          if (typeof productSliderModal?.slideToLoop === "function") {
            productSliderModal.slideToLoop(index, 500);
          } else if (productSliderModal) {
            productSliderModal.slideTo(index, 500);
          }
        }
      });

      productSliderModal1.on("hide.bs.modal", function () {
        const index =
          typeof productSlider?.realIndex === "number"
            ? productSlider.realIndex
            : 0;
        const currentModalIdx =
          typeof productSliderModal?.realIndex === "number"
            ? productSliderModal.realIndex
            : -1;
        if (index !== currentModalIdx) {
          if (typeof productSlider?.slideToLoop === "function") {
            productSlider.slideToLoop(currentModalIdx, 500);
          } else if (productSlider) {
            productSlider.slideTo(currentModalIdx, 500);
          }
        }
      });
    }
  });

  const bannerThumbnails = new Swiper("[data-pl-carousel=bannerThumbnails]", {
    spaceBetween: 0,
    lazy: true,
    freeMode: false,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 4,
      },
      1400: {
        slidesPerView: 5,
      },
    },
  });

  const mainCarousel = new Swiper("[data-pl-carousel=mainCarousel]", {
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      620: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 1,
      },
    },
    thumbs: {
      swiper: bannerThumbnails,
    },
  });

  // banery kampanii promocyjnych na karcie produktu; partial wstawia go dopiero
  // przy dwoch i wiecej banerach (layout/partials/product-promo-banner.phtml)
  const promoBanners = new Swiper("[data-pl-carousel=promoBanners]", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    // banery kampanii bywaja roznej wysokosci - bez tego slider trzymalby najwyzszy
    autoHeight: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: ".promo-banner-next",
      prevEl: ".promo-banner-prev",
    },
  });

  const mobileCategoriesSwiper = new Swiper(
    "[data-pl-carousel=mobile-categories]",
    {
      slidesPerView: 3,
      spaceBetween: 10,
      lazy: true,
      freeMode: {
        enabled: true,
      },
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 3.4,
        },
        576: {
          slidesPerView: 4.4,
        },
        768: {
          slidesPerView: 5.4,
        },
        992: {
          slidesPerView: 6.4,
        },
      },
    }
  );

  const proposedProductsSwiper = new Swiper(
    "[data-pl-carousel=proposedProducts]",
    {
      slidesPerView: 2,
      spaceBetween: 10,
      lazy: true,
      freeMode: {
        enabled: true,
      },
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 2.4,
        },
        576: {
          slidesPerView: 3.4,
        },
        768: {
          slidesPerView: 4.4,
        },
        992: {
          slidesPerView: 5.4,
        },
        1200: {
          slidesPerView: 6.4,
        },
      },
    }
  );

  $(function () {
    $("#switchUserModal").on("shown.bs.modal", function () {
      const companiesSwiper = new Swiper("[data-pl-carousel=alwaysOneNoLoop]", {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });
  });
};

const createAddressSwiper = function () {
  if ($("#billData").length > 0) {
    const addressSwiper = new Swiper("[data-pl-carousel=addressSwiper]", {
      slidesPerView: 1,
      spaceBetween: 25,
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    const addressSwiperOne = new Swiper("[data-pl-carousel=addressSwiperOne]", {
      slidesPerView: 1,
      spaceBetween: 25,
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  } else {
    const addressSwiper = new Swiper("[data-pl-carousel=addressSwiper]", {
      spaceBetween: 10,
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 2,
        },
      },
    });
  }

  $(".address-card").on("click", function (e) {
    if (!$(e.target).is(":button, button > img")) {
      const el = $(this);
      if (!el.hasClass("active-base") && !el.hasClass("disabled-item")) {
        window.spinner.show(el);
        el.find(".set-primary").trigger("submit");
      }
    }
  });
};

const createProdCatSwiper = function () {
  const productCategoriesSwiper = new Swiper(
    "[data-pl-carousel=prod-list-cat-swiper]",
    {
      slidesPerView: 4,
      spaceBetween: 10,
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 2,
        },
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
      },
    }
  );
};

export { bind, createAddressSwiper, createProdCatSwiper };
